import React from "react";
import { Helmet } from "react-helmet-async";
import SectionHeading from "../components/SectionHeading";
import SocialLinks from "../components/SocialLinks";
import "./Contact.css";

/**
 * Contact Page
 * Get in touch with AxiomLabs Solutions - premium edition
 */
function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact — Get In Touch | AxiomLabs Solutions</title>
        <meta
          name="description"
          content="Have questions about our security, AI, or compliance tools? Contact the engineers who built them. No ticket queues, direct access to the team."
        />
      </Helmet>
      <div className="contact-page">
        {/* Hero */}
        <div className="contact-hero">
          <div className="container">
            <SectionHeading
              eyebrow="Contact Us"
              title="Get In Touch"
              subheading="Have questions about our products or need support? Talk directly to the engineers who built the tools."
            />
          </div>
        </div>

        <div className="container">
          <div className="contact-content">
            {/* Intro */}
            <div className="contact-intro">
              <p>
                Whether you have questions about our products, need technical
                support, or want to discuss a custom solution, we're here to
                help. No ticket queues — you talk directly to the people who
                build the tools.
              </p>
            </div>

            {/* Methods */}
            <div className="contact-methods">
              <div className="contact-method-card">
                <div className="contact-method-card__icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="M22 7l-10 7L2 7" />
                  </svg>
                </div>
                <h3 className="contact-method-card__title">Email</h3>
                <p className="contact-method-card__text">
                  The fastest way to reach us. We typically respond within 24
                  hours.
                </p>
                <a
                  href="mailto:axiomlabssolutions@gmail.com"
                  className="contact-method-card__link"
                >
                  axiomlabssolutions@gmail.com
                  <span className="contact-method-card__arrow">→</span>
                </a>
              </div>

              <div className="contact-method-card">
                <div className="contact-method-card__icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                  </svg>
                </div>
                <h3 className="contact-method-card__title">Social Media</h3>
                <p className="contact-method-card__text">
                  Follow us for updates, announcements, and community
                  discussions.
                </p>
                <SocialLinks include={['github', 'twitter', 'email']} />
              </div>
            </div>

            {/* CTA */}
            <div className="contact-cta-card">
              <div className="contact-cta-card__content">
                <h2 className="contact-cta-card__title">
                  Ready to Get Started?
                </h2>
                <p className="contact-cta-card__text">
                  Interested in any of our products or have a specific
                  requirement? Don't hesitate to reach out. We're always happy
                  to discuss how our tools can help you achieve your goals.
                </p>
                <a
                  href="mailto:axiomlabssolutions@gmail.com"
                  className="contact-cta-card__button"
                >
                  <span>Start the Conversation</span>
                  <span className="contact-cta-card__arrow">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
